import { tyreListQuerySchema, type TyreStatus } from '@chukua/common';
import { Select } from 'antd';
import { useCallback } from 'react';
import { useRemoteSearchOptions } from '../../../../../shared/hooks/use-remote-search-options';
import { TYRE_STATUS_LABELS } from '../policies/tyre-labels';
import { listTyres } from '../tyres.api';

const PAGE_SIZE = 20;

interface TyreSearchSelectProps {
  id?: string;
  value?: string;
  onChange?: (value: string | undefined) => void;
  /** Which tyres may be picked: the ones that can go on a vehicle are `new` and `in_stock`. */
  statuses: TyreStatus[];
  /** A tyre that must not be offered, e.g. the one being replaced. */
  excludeId?: string;
}

/** Remote-search picker over tyres by serial or brand, opening on the first page. */
export function TyreSearchSelect({ id, value, onChange, statuses, excludeId }: TyreSearchSelectProps) {
  const fetchTyres = useCallback(
    (q: string | undefined) =>
      listTyres(tyreListQuerySchema.parse({ q, status: statuses, pageSize: PAGE_SIZE })).then((page) =>
        page.items
          .filter((tyre) => tyre.id !== excludeId)
          .map((tyre) => ({ value: tyre.id, label: `${tyre.serial} · ${tyre.brand} ${tyre.size} (${TYRE_STATUS_LABELS[tyre.status]})` })),
      ),
    [statuses, excludeId],
  );
  const { selectProps } = useRemoteSearchOptions(fetchTyres);

  return (
    <Select
      {...selectProps}
      id={id}
      value={value}
      onChange={onChange}
      placeholder="Select or search tyres"
      notFoundContent={selectProps.loading ? 'Searching…' : 'No tyres found'}
    />
  );
}
